export default "__VITE_ASSET__D$2OOD93__"